module.exports = __webpack_public_path__ + "static/media/onboarding_deviens_ls.8264e0f2.png";